import { render, staticRenderFns } from "./EditSellerSuspensionDialogContent.vue?vue&type=template&id=d0dcafe4&scoped=true&"
import script from "./EditSellerSuspensionDialogContent.vue?vue&type=script&lang=js&"
export * from "./EditSellerSuspensionDialogContent.vue?vue&type=script&lang=js&"
import style0 from "./EditSellerSuspensionDialogContent.vue?vue&type=style&index=0&id=d0dcafe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0dcafe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VIcon,VLayout})
